import React from 'react';
import banner2 from '../assets/banner2.png';
import { InlineWidget } from "react-calendly";
import faqBg from '../assets/faq.png';
import connect from '../assets/Connect.png';
import { MapPin, Phone, Mail } from 'lucide-react';
const Connect = () => {


  return (
    <div className="bg-white min-h-screen">
      {/* ================= HERO SECTION (Standard Theme) ================= */}
      <section
        className="relative py-16 md:py-24 text-center overflow-hidden"
        style={{
          backgroundImage: `url(${banner2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/*
        <h3 className="relative z-10 font-syne text-[28px] md:text-[40px] text-slate-900 tracking-tight font-medium">
          Contact Us
        </h3>
*/}

         <h3 className="relative z-10 font-syne text-[24px] md:text-[32px] text-slate-900 tracking-tight font-medium">
          Contact Us
        </h3>
{/*
         <h3 className="relative z-10 font-syne text-2xl md:text-3xl text-slate-900 tracking-tight font-medium">
          Contact Us
        </h3>
*/}
        <div
          className="pointer-events-none absolute bottom-0 left-0 w-full h-[120px]"
          style={{
            background:
              "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 40%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,1) 100%)",
          }}
        />
      </section>

      {/* ================= CONNECT DETAILS SECTION ================= */}
    {/* ================= CONNECT DETAILS SECTION ================= */}
 {/*   
<section 
  className="py-20"
 
>
  <div className="max-w-7xl mx-auto px-6 lg:px-24 ">
    <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
      
      
      <motion.div 
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="w-full lg:w-1/2"
      >
        
        <div className="relative shadow-xl border border-gray-200">
          <img 
            src={connectImg} 
            alt="Contact Us Illustration" 
            className="w-full h-auto object-cover" 
          />
        </div>
      </motion.div>

      
      <motion.div 
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="w-full lg:w-1/2"
      >
        
         <h2 className="font-syne text-2xl md:text-4xl font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter -mt-2">Connect with us</h2>

        <div className="relative space-y-12 -mt-4">
        
          <div className="absolute left-[21px] top-4 bottom-4 w-[2px] bg-[#434242] z-0 hidden md:block " />

          {contactDetails.map((item, idx) => (
            <div key={idx} className="relative z-10 flex items-start gap-6 group">
              
             
              <div className="flex-shrink-0 w-11 h-11 bg-red-600 border-2 border-[#434242] rotate-45 flex items-center justify-center shadow-lg transition-transform duration-300 group-hover:scale-110">
                <div className="-rotate-45">
                  {item.icon}
                </div>
              </div>

              <div className="flex flex-col">
                <span className="text-slate-900 font-bold text-sm tracking-widest mb-1">
                  {item.title}
                </span>
                <p className="text-slate-600 text-base md:text-lg leading-relaxed max-w-sm">
                  {item.info}
                </p>
              </div>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  </div>
</section>
*/}

{/*
<section className="py-24 bg-[#fcfcfc] overflow-hidden">
  <div className="max-w-7xl mx-auto px-6 lg:px-24">
    <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
      
      
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="w-full lg:w-1/2 relative"
      >
        <div className="relative z-10 shadow-2xl overflow-hidden">
          <img 
            src={connectImg} 
            alt="Contact Us" 
            className="w-full h-[500px] object-cover" 
          />
        </div>
        
        <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-red-600/10 -z-0 hidden md:block" />
      </motion.div>

      
      <div className="w-full lg:w-1/2">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="font-syne text-3xl md:text-5xl font-bold text-slate-900 mb-2 tracking-tight">
            Connect with us
          </h2>
          <div className="w-20 h-1.5 bg-red-600 mb-12" />
        </motion.div>

        <div className="grid grid-cols-1 gap-8">
          {contactDetails.map((item, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: idx * 0.1 }}
              viewport={{ once: true }}
              className="group flex items-center gap-6 p-6 bg-white border border-slate-100 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
            >
              
              <div className="flex-shrink-0 w-14 h-14 bg-slate-50 text-red-600 rounded-xl flex items-center justify-center group-hover:bg-red-600 group-hover:text-white transition-colors duration-300">
                <div className="scale-110">
                  {item.icon}
                </div>
              </div>

              <div className="flex flex-col">
                <span className="text-red-600 font-bold text-xs uppercase tracking-[0.2em] mb-1">
                  {item.title}
                </span>
                <p className="text-slate-800 text-lg md:text-xl font-medium leading-tight">
                  {item.info}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

    </div>
  </div>
</section>
*/}
      {/* ================= BOTTOM CTA: SCHEDULE MEETING ================= */}
    

<section className="pb-24 pt-24 bg-white relative overflow-hidden">
  {/* Theme Watermark */}
  <div className="absolute inset-0 opacity-[0.03] pointer-events-none" 
       style={{ backgroundImage: `url(${faqBg})`, backgroundSize: '600px' }}></div>

  <div className="max-w-7xl mx-auto px-6 lg:px-24 relative z-10">
    <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-center">
      
      {/* LEFT SIDE: Image */}
      <div className="lg:w-1/2">
        {/* IMAGE PLACED BELOW DESCRIPTION */}
          <div className="rounded-2xl overflow-hidden   group">
             <img 
              src={connect} 
              alt="DreamLadder Office" 
              className="w-full h-[280px] object-cover  group-hover:grayscale-0 transition-all duration-1000"
            />
          </div>
      </div>

      {/* RIGHT SIDE: Simplified Information */}
      <div className="lg:w-1/2 space-y-10">
        

        <div className="group flex items-center gap-6">
  <div
    className="
      w-12 h-12
      bg-red-50 text-red-600
      rounded-xl
      flex items-center justify-center
      transition-colors duration-300
      group-hover:bg-red-600
      group-hover:text-white
    "
  >
    <Phone size={22} />
  </div>

  <p className="text-slate-900 text-lg md:text-xl font-medium leading-relaxed">
    +91 89-0808-2222
  </p>
</div>


        {/* EMAIL */}
        {/* EMAIL */}
<div className="group flex items-center gap-6">
  <div
    className="
      w-12 h-12
      bg-red-50 text-red-600
      rounded-xl
      flex items-center justify-center
      transition-colors duration-300
      group-hover:bg-red-600
      group-hover:text-white
    "
  >
    <Mail size={22} />
  </div>

  <p className="text-slate-900 text-lg md:text-xl font-medium leading-relaxed break-all">
    info@dreamladdercapital.com
  </p>
</div>
        {/* ADDRESS */}
       {/* ADDRESS */}
<div className="group flex items-start gap-6">
  <div
    className="
      mt-1 w-12 h-12
      bg-red-50 text-red-600
      rounded-xl
      flex items-center justify-center
      transition-colors duration-300
      group-hover:bg-red-600
      group-hover:text-white
    "
  >
    <MapPin size={22} />
  </div>

  <p className="text-slate-900 text-lg md:text-xl font-medium leading-relaxed">
   #20, 10th floor, R. City Offices, LBS Marg, <br className="hidden md:block"/>
    Ghatkopar (West), Mumbai - 400086 <br className="hidden md:block"/>
  </p>
</div>


        {/* MOBILE */}
       {/* MOBILE */}



      </div>
    </div>
  </div>
</section>
   {/* ================= SCHEDULE A MEETING SECTION ================= */}
     
<section className="pt-4  bg-white relative">
  <div className="max-w-7xl mx-auto px-6 lg:px-24 mb-14">
    {/* Heading: Exact color #002e5b and font-syne 
    <h2 className="text-center font-syne text-[32px] md:text-[38px] text-[#002e5b] font-bold mb-16">
      Schedule a Meeting
    </h2>
*/}
   
     <h2 className="font-syne text-[24px] md:text-[32px] -mb-2 -md:mb-4 font-thin text-black/70  leading-[1.1] whitespace-pre-line tracking-tighter text-center">Schedule a Meeting</h2>
      
    
    {/* Calendly Card with exact shadow from your reference */}
    <div className="w-full min-h-[700px] overflow-hidden">
      <InlineWidget 
        /* ACTION REQUIRED: Paste your EXACT Calendly link here. 
           Example: "https://calendly.com/your-name/your-event"
        */
        url="https://calendly.com/dreamladdercapital/portfolio-discussion-meeting" 
        styles={{
          height: '750px',
          width: '100%'
        }}
        pageSettings={{
          backgroundColor: 'ffffff',
          hideEventTypeDetails: false,
          hideLandingPageDetails: true,
          primaryColor: 'e31e24', // Brand Red for buttons/dates
          textColor: '1a1a1a'
        }}
      />
    </div>
  </div>

  {/* FLOATING CHAT BUTTON (Bottom Right - Exactly like screenshot) */}
  <div className="fixed bottom-6 right-6 z-[9999] cursor-pointer group">
    <div className="w-14 h-14 bg-[#e31e24] rounded-full flex items-center justify-center shadow-2xl transition-transform duration-300 group-hover:scale-110">
      {/* SVG for the white chat bubble icon */}
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 11.5C21 16.1944 16.9706 20 12 20C10.5113 20 9.10931 19.6574 7.8821 19.05L3 20.5L4.5 15.6179C3.56477 14.4174 3 13.0232 3 11.5C3 6.80558 7.02944 3 12 3C16.9706 3 21 6.80558 21 11.5Z" fill="white"/>
      </svg>
    </div>
  </div>
</section>

{/* ================= QUERY FORM & MAP SECTION ================= */}


<section className="pb-12 -mt-16 bg-white">
  <div className="max-w-7xl mx-auto px-6 lg:px-24">

    {/* HEADER */}
    <div className="text-center mb-14">
    {/*  <h2 className="font-syne text-2xl md:text-4xl font-thin text-black/70 leading-[1.1] tracking-tighter">
        Have a Question?
      </h2> */}
      <h2 className="font-syne text-[24px] md:text-[32px] font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter">Have a Question?</h2>
      
     
    </div>

    {/* ONE FRAME */}
   {/* ONE FRAME (NO OUTER BOX NOW) */}
<div className="p-8 md:p-10 -mt-10">

  {/* FORM ROW */}
  <form className="grid grid-cols-1 lg:grid-cols-2 gap-8">

    {/* LEFT */}
    <div className="space-y-5">
      <input
        type="text"
        placeholder="Your name"
        className="w-full px-5 py-3.5 text-base bg-transparent
        border border-slate-300 rounded-xl
        placeholder:text-slate-400
        focus:outline-none focus:border-red-600 focus:ring-1 focus:ring-red-600/20
        transition"
      />

      <input
        type="email"
        placeholder="Your email"
        className="w-full px-5 py-3.5 text-base bg-transparent
        border border-slate-300 rounded-xl
        placeholder:text-slate-400
        focus:outline-none focus:border-red-600 focus:ring-1 focus:ring-red-600/20
        transition"
      />

      <input
        type="tel"
        placeholder="Phone"
        className="w-full px-5 py-3.5 text-base bg-transparent
        border border-slate-300 rounded-xl
        placeholder:text-slate-400
        focus:outline-none focus:border-red-600 focus:ring-1 focus:ring-red-600/20
        transition"
      />
    </div>

    {/* RIGHT */}
    <div className="flex flex-col justify-between gap-5">
      <textarea
        rows={4}
        placeholder="Your message (optional)"
        className="w-full px-5 py-4 text-base bg-transparent
        border border-slate-300 rounded-xl
        placeholder:text-slate-400 resize-none
        focus:outline-none focus:border-red-600 focus:ring-1 focus:ring-red-600/20
        transition"
      />

      <button
        type="submit"
        className="self-start inline-flex items-center
        px-10 py-1.5
        bg-red-600 border-2 border-red-600 text-white rounded-full
        hover:bg-[#434242] hover:border-[#434242]
        transition duration-300 font-medium text-[13px] md:text-[15px]"
      >
        Submit
      </button>
    </div>
  </form>

  {/* MAP 
  <div className="mt-10">
    <div className="w-full h-[260px] md:h-[300px]
      rounded-xl overflow-hidden border border-slate-100">
      <iframe
        src="https://www.google.com/maps?ll=19.100487,72.917023&z=17&t=m&hl=en&gl=IN&mapclient=embed&cid=5250521627945001308&output=embed"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
      />
    </div>
  </div>
*/}
   <div className="mt-10">
      <div className="w-full h-[300px] md:h-[320px]
        rounded-xl overflow-hidden
        shadow-md border border-slate-100">

        <iframe
          src="https://www.google.com/maps?ll=19.100487,72.917023&z=17&t=m&hl=en&gl=IN&mapclient=embed&cid=5250521627945001308&output=embed"
          title="DreamLadder Capital Location Map"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>

</div>

  </div>
</section>


    </div>
  );
};

export default Connect;